import React, { useEffect, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Styles
import "./styles/browser-fixes.css";

// Components
const Navigation = React.lazy(() => import("./components/Navigation"));
const Hero = React.lazy(() => import("./components/Hero"));
const About = React.lazy(() => import("./components/About"));
const Skills = React.lazy(() => import("./components/Skills"));
const Experience = React.lazy(() => import("./components/Experience"));
const Contact = React.lazy(() => import("./components/Contact"));
const Footer = React.lazy(() => import("./components/Footer"));
import { Toaster } from "./components/ui/toaster";

// Data
import portfolioData from "./data/content.json";

// Backend configuration (temporarily disabled)
// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

const Portfolio = () => {
    // Backend connection test (temporarily disabled)
    // useEffect(() => {
    //   const testBackend = async () => {
    //     try {
    //       const response = await axios.get(`${API}/`);
    //       console.log('Backend connected:', response.data.message);
    //     } catch (e) {
    //       console.log('Backend not available, using mock data');
    //     }
    //   };
    //   testBackend();
    // }, []);

  // Scroll to top functionality
  useEffect(() => {
    const handleScroll = () => {
      const scrollButton = document.getElementById('scroll-to-top');
      if (scrollButton) {
        scrollButton.style.display = window.pageYOffset > 300 ? 'flex' : 'none';
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen">

      {/* Navigation */}
          <Suspense fallback={<div>Loading...</div>}>
              <Navigation />
          </Suspense>

      {/* Main Content */}
      <main>
              <Suspense fallback={<div>Loading...</div>}>
                  <Hero data={portfolioData.hero} />
              </Suspense>
              <Suspense fallback={<div>Loading...</div>}>
                  <About data={portfolioData.about} />
              </Suspense>
              <Suspense fallback={<div>Loading...</div>}>
                  <Skills data={portfolioData.skills} />
              </Suspense>
              <Suspense fallback={<div>Loading...</div>}>
                  <Experience data={portfolioData.experience} />
              </Suspense>
              <Suspense fallback={<div>Loading...</div>}>
                  <Contact data={portfolioData.contact} />
              </Suspense>
      </main>

      {/* Footer */}
          <Suspense fallback={<div>Loading...</div>}>
              <Footer contactData={portfolioData.contact} />
          </Suspense>

      {/* Scroll to Top Button */}
      <button
        id="scroll-to-top"
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 rounded-full shadow-lg items-center justify-center z-50 neekocode-btn-primary"
              style={{
          display: 'none',
          fontSize: '20px',
          fontWeight: 'bold'
        }}
      >
        ↑
      </button>

      {/* Toast Notifications */}
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
          <a
              href="#main-content"
              className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 z-50 neekocode-btn neekocode-btn-primary"
              onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('main-content')?.focus();
              }}
          >
              Passer au contenu principal
          </a>

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
